export default {
    name: "HasErrors",
    props: {
        errors: Object,
    },
    computed: {
        hasErrors() {
            return !$.isEmptyObject(this.errors);
        },
    },
};
